import AdminTable from 'common/AdminTable';
import { deleteRequest, getRequest, patchRequest } from 'apis/ApiInstence';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

const SiteSetupList = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const res = await getRequest('sitesetup');
      setRecords(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to load site setup');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleToggle = async (id) => {
    try {
      await patchRequest(`sitesetup/${id}/toggle`, {});
      toast.success('Status updated successfully');
      fetchRecords();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update status');
    }
  };

  const handleRemove = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This site setup record will be deleted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        await deleteRequest(`sitesetup/${id}`);
        toast.success('Site setup deleted successfully');
        fetchRecords();
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to delete site setup');
      }
    });
  };

 const tableHeaders = [
  { Header: 'ID', accessor: 'id' },
  { Header: 'Mobile', accessor: 'mobile_number' },
  { Header: 'WhatsApp', accessor: 'whatsapp_number' },
  { Header: 'Email', accessor: 'email' },
  { Header: 'Address', accessor: 'address' },

  // REMOVE THIS MAP LINK COLUMN
  // { Header: 'Map Link', accessor: 'map_link' },

  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }) => (
      <button
        type="button"
        className={`btn btn-sm ${
          row.original.status === 'active'
            ? 'btn-success'
            : 'btn-secondary'
        }`}
        onClick={() => handleToggle(row.original.id)}
      >
        {row.original.status === 'active'
          ? 'Active'
          : 'Inactive'}
      </button>
    ),
  },

  {
    Header: 'Actions',
    accessor: 'actions',
    Cell: ({ row }) => (
      <>
        <button
          className="btn editbtn mx-1 my-1"
          onClick={() =>
            navigate(
              `/sitesetup/update/${row.original.id}`
            )
          }
        >
          Edit
        </button>

        <button
          className="btn removebtn mx-1 my-1"
          onClick={() =>
            handleRemove(row.original.id)
          }
        >
          Remove
        </button>
      </>
    ),
  },
];

  if (loading) return <div className="text-center mt-5">Loading site setup...</div>;

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between mb-4 mx-4">
        <div className="mainheadig mb-0">
          <h4 className="font-weight-bold">Site Setup List</h4>
        </div>
        {records.length === 0 && (
          <button className="btn addbtn" onClick={() => navigate('/sitesetup/add')}>
            + Add Site Setup
          </button>
        )}
      </div>

      <AdminTable tableHeaders={tableHeaders} tableData={records} />
    </div>
  );
};

export default SiteSetupList;
